module.exports = __webpack_public_path__ + "static/media/partitions_allImpact_60yd_n.e9a881af.csv";